module.exports = __webpack_public_path__ + "static/top-d21199550bb6f2cb259ead6edb5ffe17.png";